// apiConfig.js


// const API_BASE_URL = 'http://localhost/stockexploder/';

// const API_BASE_URL = 'https://test.swingalgo.com/stockexploder/';

const API_BASE_URL = 'https://www.swingalgo.com/stockexploder/';


export  {API_BASE_URL};
